const getRegularNotesCount = (notes: string[]) => {
  const regularNotesCount = notes?.filter(
    (n) =>
      !n.includes("Assigned") &&
      !n.includes("Issue status") &&
      !n.includes("Survey/Zoning Status:") &&
      !n.includes("ETA Requested") &&
      !n.includes("ETA Accuracy Requested") &&
      !n.includes("ETA Confirmed")
  ).length;
  return regularNotesCount;
};

export default getRegularNotesCount;
